import React from 'react';

import { cf } from './c_20210427a_YSh/cf';
import { ce } from './c_20210427a_YSh/ce';
import { iv } from './c_20210427a_YSh/iv';
import { ic } from './c_20210427a_YSh/ic';
import { bf } from './c_20210427a_YSh/bf';
import { cp } from './c_20210427a_YSh/cp';
import { ip } from './c_20210427a_YSh/ip';

import cView from './c_20210427a_YSh/cView';

export default class iPrcDtl extends cView {

  constructor(props) { // state の宣言だけでは駄目な模様
    super(props);
    this.state = cf.myRN_crt_stss(
      this.$cd_stss,
      this.$id_stss
    );
  };

  $id_stss = {
    s_cm40c310: '',
    sdd_it10ss: {},
    sld_chkIss: [
    ],
    sld_caseIss: [
    ],
    sld_filess: [],
  };

  $ilp_bfrLoads = () => [
    cp.$cp_hlr_cm31({
      mode: 'set',
      cnd: bf.q(`
        [cm31b11k]="{}" AND 
        [cm31b21k]="{}" AND 
        [cm31b31k]="{}"
      `.f(
        global.c?.state.sgcd_pagePntKeys.cm20_key,
        global.c?.state.sgcd_pagePntKeys.cm30_key,
        global.c?.state.sgcd_pagePntKeys.cm10_key,
      )),
    }),

    cp.$cp_hlr_cm30({ // 分類情報
      mode: 'set',
      cnd: bf.q(`
        [cm30b11k]="{}" AND 
        [_KEY]={}
      `.f(
        global.c?.state.sgcd_pagePntKeys.cm20_key,
        global.c?.state.sgcd_pagePntKeys.cm30_key,
      )),
    }),

  ];

  $ilp_loads = () => [

    cp.$cp_hlr_cm40({ // 分類情報
      mode: 'set',
      b_clr: (global.c?.state.sgc_pageMode == 'new') ? true : false,
      cm40_key: global.c?.state.sgc_pageKey,
    }),

    cp.$cp_hlr_ct10({
      mode: 'set',
      cnd: ip.$o_pmn({
        mode: 'cndCt10',
        t110: '20',
        tgt: 'cm40',
      }),
      state: 'sld_filess1',
      ld_sortss: [
        {fld: 'ct10t110', dtn: 'desc', mode: 'nmb'},
        {fld: '_KEY', dtn: 'asc', mode: 'nmb'},
      ],
      dd_rfrss: {
        cm10: {
          elm: 'cm10',
          o_cnd: _d_flds => bf.q('[_KEY]={}'.f(_d_flds.ct10cy20)),
        },
      },
    }),

    cp.$cp_hlr_ct10({
      mode: 'set',
      cnd: ip.$o_pmn({
        mode: 'cndCt10',
        t110: '10',
        tgt: 'cm40',
      }),
      state: 'sld_filess2',
      ld_sortss: [
        {fld: 'ct10t110', dtn: 'desc', mode: 'nmb'},
        {fld: '_KEY', dtn: 'asc', mode: 'nmb'},
      ],
      dd_rfrss: {
        cm10: {
          elm: 'cm10',
          o_cnd: _d_flds => bf.q('[_KEY]={}'.f(_d_flds.ct10cy20)),
        },
      },
    }),

    global.c?._op_load11(),
    global.c?._op_load12(),
    global.c?._op_load21(),
    global.c?._op_load22(),
  ];

_op_load11 = () => cf.myCB_call_tree({
  ctr: 'slc',
  state: 'sdld_chkIss1',
  dd_elmDefss: {
    it10: { // alias
      elm: 'it10',
      o_cnd: _dd_prtss => {
        let _cnd = null;
        if (global.c?.state.sgcd_pagePntKeys.cm31c410 == '20') { // 設定タブ
          _cnd = bf.q(`
            [it10b11k]="{}" AND 
            [it10l11e]="prcChk" AND 
            [it10l11k]="{}" AND 
            [it10t110]="20" AND 
            IFNULL([it10cz10],"10")<>"0"
          `.f(
            global.c?.state.sgcd_pagePntKeys.cm20_key,
            global.c?.state.sgc_pageKey,
          ));
        }
        else { // 閲覧タブ
          _cnd = bf.q(`
            [it10b11k]="{}" AND 
            [it10l11e]="prcChk" AND 
            [it10l11k]="{}" AND
            (
              [it10t110]="20"
            ) AND
            IFNULL([it10cz10],"10")<>"0"
          `.f(
            global.c?.state.sgcd_pagePntKeys.cm20_key,
            global.c?.state.sgc_pageKey,
            global.c?.state.sgcd_pagePntKeys.cm10_key,
          ));
        };
        return _cnd;
      },
      dd_rfrss: {
        cm10: {
          elm: 'cm10',
          o_cnd: _d_flds => (bf.f(_d_flds.it10b21k)) ? bf.q('[_KEY]={}'.f(_d_flds.it10b21k)) : null,
        },
      },
      ld_sortss: [
        {fld: 'it10t110', dtn: 'desc', mode: 'nmb'},
        {fld: '_KEY', dtn: 'asc', mode: 'nmb'},
      ],
    },
  },
});

_op_load12 = () => cf.myCB_call_tree({
  ctr: 'slc',
  state: 'sdld_chkIss2',
  dd_elmDefss: {
    it10: { // alias
      elm: 'it10',
      o_cnd: _dd_prtss => {
        let _cnd = null;
        if (global.c?.state.sgcd_pagePntKeys.cm31c410 == '20') { // 設定タブ
          _cnd = bf.q(`
            [it10b11k]="{}" AND 
            [it10l11e]="prcChk" AND 
            [it10l11k]="{}" AND 
            [it10t110]="10" AND 
            IFNULL([it10cz10],"10")<>"0"
          `.f(
            global.c?.state.sgcd_pagePntKeys.cm20_key,
            global.c?.state.sgc_pageKey,
          ));
        }
        else { // 閲覧タブ
          _cnd = bf.q(`
            [it10b11k]="{}" AND 
            [it10l11e]="prcChk" AND 
            [it10l11k]="{}" AND
            (
              [it10t110]="10" AND 
              [it10b21k]="{}"
            ) AND
            IFNULL([it10cz10],"10")<>"0"
          `.f(
            global.c?.state.sgcd_pagePntKeys.cm20_key,
            global.c?.state.sgc_pageKey,
            global.c?.state.sgcd_pagePntKeys.cm10_key,
          ));
        };
        return _cnd;
      },
      dd_rfrss: {
        cm10: {
          elm: 'cm10',
          o_cnd: _d_flds => (bf.f(_d_flds.it10b21k)) ? bf.q('[_KEY]={}'.f(_d_flds.it10b21k)) : null,
        },
      },
      ld_sortss: [
        {fld: 'it10t110', dtn: 'desc', mode: 'nmb'},
        {fld: '_KEY', dtn: 'asc', mode: 'nmb'},
      ],
    },
  },
});

_op_load21 = () => cf.myCB_call_tree({
  ctr: 'slc',
  state: 'sdld_caseIss1',
  dd_elmDefss: {
    it10: { // alias
      elm: 'it10',
      o_cnd: _dd_prtss => {
        let _cnd = null;
        if (global.c?.state.sgcd_pagePntKeys.cm31c410 == '20') { // 部門運営者
          _cnd = bf.q(`
            [it10b11k]="{}" AND 
            [it10l11e]="prcCase" AND 
            [it10l11k]="{}" AND 
            [it10t110]="20" AND 
            IFNULL([it10cz10],"10")<>"0"
          `.f(
            global.c?.state.sgcd_pagePntKeys.cm20_key,
            global.c?.state.sgc_pageKey,
          ));
        }
        else { // 一般利用者
          _cnd = bf.q(`
            [it10b11k]="{}" AND 
            [it10l11e]="prcCase" AND 
            [it10l11k]="{}" AND 
            (
              [it10t110]="20"
            ) AND
            IFNULL([it10cz10],"10")<>"0"
          `.f(
            global.c?.state.sgcd_pagePntKeys.cm20_key,
            global.c?.state.sgc_pageKey,
            global.c?.state.sgcd_pagePntKeys.cm10_key,
          ));
        };
        return _cnd;
      },
      dd_rfrss: {
        cm10: {
          elm: 'cm10',
          o_cnd: _d_flds => (bf.f(_d_flds.it10b21k)) ? bf.q('[_KEY]={}'.f(_d_flds.it10b21k)) : null,
        },
      },
      ld_sortss: [
        {fld: 'it10t110', dtn: 'desc', mode: 'nmb'},
        {fld: '_KEY', dtn: 'asc', mode: 'nmb'},
      ],
    },
  }

});

_op_load22 = () => cf.myCB_call_tree({
  ctr: 'slc',
  state: 'sdld_caseIss2',
  dd_elmDefss: {
    it10: { // alias
      elm: 'it10',
      o_cnd: _dd_prtss => {
        let _cnd = null;
        if (global.c?.state.sgcd_pagePntKeys.cm31c410 == '20') { // 部門運営者
          _cnd = bf.q(`
            [it10b11k]="{}" AND 
            [it10l11e]="prcCase" AND 
            [it10l11k]="{}" AND 
            [it10t110]="10" AND 
            IFNULL([it10cz10],"10")<>"0"
          `.f(
            global.c?.state.sgcd_pagePntKeys.cm20_key,
            global.c?.state.sgc_pageKey,
          ));
        }
        else { // 一般利用者
          _cnd = bf.q(`
            [it10b11k]="{}" AND 
            [it10l11e]="prcCase" AND 
            [it10l11k]="{}" AND 
            (
              [it10t110]="10" AND 
              [it10b21k]="{}"
            ) AND
            IFNULL([it10cz10],"10")<>"0"
          `.f(
            global.c?.state.sgcd_pagePntKeys.cm20_key,
            global.c?.state.sgc_pageKey,
            global.c?.state.sgcd_pagePntKeys.cm10_key,
          ));
        };
        return _cnd;
      },
      dd_rfrss: {
        cm10: {
          elm: 'cm10',
          o_cnd: _d_flds => (bf.f(_d_flds.it10b21k)) ? bf.q('[_KEY]={}'.f(_d_flds.it10b21k)) : null,
        },
      },
      ld_sortss: [
        {fld: 'it10t110', dtn: 'desc', mode: 'nmb'},
        {fld: '_KEY', dtn: 'asc', mode: 'nmb'},
      ],
    },
  }

});

$ip_ins = () => cp.$cp_hlr_cm40({
  mode: 'ins',
  cm40b11k: bf.b([
    {
      b_when: global.c?.state.sgc_pageRole == 'own1',
      o_then: () => '0',
    },
    {
      o_else: () => global.c?.state.sgcd_pagePntKeys.cm20_key,
    },
  ]),
  cm40b21k: global.c?.state.sgcd_pagePntKeys.cm30_key || '0',
  cm40l11e: 'prcSht',
  cm40l11k: '1',
  cm40t110: ip.$o_pmn({
    mode: 'type',
  }),
});

$ilp_upds = () => [

  cp.$cp_hlr_cm40({
    mode: 'upd',
    cm40_key: global.c?.state.sgc_pageKey,
  }), // cm40中分類

  cf.myCB_call_tree({
    ctr: 'iud',
    state: 'sdld_chkIss1',
    dd_elmDefss: {
      it10: {
        od_insDats: pd => {
          let _d = {
            it10b11k: global.c?.state.sgcd_pagePntKeys.cm20_key || '0',
            it10b21k: global.c?.state.sgcd_pagePntKeys.cm10_key || '0',
            it10b31k: global.c?.state.sgcd_pagePntKeys.cm30_key || '0',
            it10l11e: 'prcChk',
            it10l11k: global.c?.state.sgc_pageKey,
            it10c110: '',
            it10c310: pd.it10.d_flds.it10c310,
            it10cz10: '10', // 表示 
            it10t110: ip.$o_pmn({
              mode: 'type',
            }),
            it10cy10: bf.myDT_get_now(),
            it10cy20: global.c?.state.sgcd_pagePntKeys.cm10_key || '',
            it10cx10: pd.it10.d_flds.it10cx10 || '9999',
            it10cw10: pd.it10.d_flds.it10cw10 || bf.myCM_gnr(10),
          };
          return _d;
        },
      },
    },
  }),

  cf.myCB_call_tree({
    ctr: 'iud',
    state: 'sdld_chkIss2',
    dd_elmDefss: {
      it10: {
        od_insDats: pd => {
          let _d = {
            it10b11k: global.c?.state.sgcd_pagePntKeys.cm20_key || '0',
            it10b21k: global.c?.state.sgcd_pagePntKeys.cm10_key || '0',
            it10b31k: global.c?.state.sgcd_pagePntKeys.cm30_key || '0',
            it10l11e: 'prcChk',
            it10l11k: global.c?.state.sgc_pageKey,
            it10c110: '',
            it10c310: pd.it10.d_flds.it10c310,
            it10cz10: '10', // 表示 
            it10t110: ip.$o_pmn({
              mode: 'type',
            }),
            it10cy10: bf.myDT_get_now(),
            it10cy20: global.c?.state.sgcd_pagePntKeys.cm10_key || '',
            it10cx10: pd.it10.d_flds.it10cx10 || '9999',
            it10cw10: pd.it10.d_flds.it10cw10 || bf.myCM_gnr(10),
          };
          return _d;
        },
      },
    },
  }),

  cf.myCB_call_tree({
    ctr: 'iud',
    state: 'sdld_caseIss1',
    dd_elmDefss: {
      it10: {
        od_insDats: pd => {
          let _d = {
            it10b11k: global.c?.state.sgcd_pagePntKeys.cm20_key || '0',
            it10b21k: global.c?.state.sgcd_pagePntKeys.cm10_key || '0',
            it10b31k: global.c?.state.sgcd_pagePntKeys.cm30_key || '0',
            it10l11e: 'prcCase',
            it10l11k: global.c?.state.sgc_pageKey,
            it10c110: '',
            it10c310: pd.it10.d_flds.it10c310,
            it10cz10: '10', // 表示 
            it10t110: ip.$o_pmn({
              mode: 'type',
            }),
            it10cy10: bf.myDT_get_now(),
            it10cy20: global.c?.state.sgcd_pagePntKeys.cm10_key || '',
            it10cx10: pd.it10.d_flds.it10cx10 || '9999',
            it10cw10: pd.it10.d_flds.it10cw10 || bf.myCM_gnr(10),
          };
          return _d;
        },
      },
    },
  }),

  cf.myCB_call_tree({
    ctr: 'iud',
    state: 'sdld_caseIss2',
    dd_elmDefss: {
      it10: {
        od_insDats: pd => {
          let _d = {
            it10b11k: global.c?.state.sgcd_pagePntKeys.cm20_key || '0',
            it10b21k: global.c?.state.sgcd_pagePntKeys.cm10_key || '0',
            it10b31k: global.c?.state.sgcd_pagePntKeys.cm30_key || '0',
            it10l11e: 'prcCase',
            it10l11k: global.c?.state.sgc_pageKey,
            it10c110: '',
            it10c310: pd.it10.d_flds.it10c310,
            it10cz10: '10', // 表示 
            it10t110: ip.$o_pmn({
              mode: 'type',
            }),
            it10cy10: bf.myDT_get_now(),
            it10cy20: global.c?.state.sgcd_pagePntKeys.cm10_key || '',
            it10cx10: pd.it10.d_flds.it10cx10 || '9999',
            it10cw10: pd.it10.d_flds.it10cw10 || bf.myCM_gnr(10),
          };
          return _d;
        },
      },
    },
  }),

  cp.$cp_hlr_ct10({ // ファイル情報
    mode: 'upd',
    elm: 'cm40',
    key: global.c?.state.sgc_pageKey,
    state: 'sld_filess1',
    ct10t110: '20',
  }),

  cp.$cp_hlr_ct10({ // ファイル情報
    mode: 'upd',
    elm: 'cm40',
    key: global.c?.state.sgc_pageKey,
    state: 'sld_filess2',
    ct10t110: '10',
  }),

/*
  new Promise( async _o_end1 => {
bf.l('482: here')
    await cp.$cp_hlr_cm40({
      mode: 'upd',
      cm40_key: global.c?.state.sgc_pageKey,
    });

    await cf.myCB_call_tree({
      ctr: 'iud',
      state: 'sdld_chkIss1',
      dd_elmDefss: {
        it10: {
          od_insDats: pd => {
            let _d = {
              it10b11k: global.c?.state.sgcd_pagePntKeys.cm20_key || '0',
              it10b21k: global.c?.state.sgcd_pagePntKeys.cm10_key || '0',
              it10b31k: global.c?.state.sgcd_pagePntKeys.cm30_key || '0',
              it10l11e: 'prcChk',
              it10l11k: global.c?.state.sgc_pageKey,
              it10c110: '',
              it10c310: pd.it10.d_flds.it10c310,
              it10cz10: '10', // 表示 
              it10t110: ip.$o_pmn({
                mode: 'type',
              }),
              it10cy10: bf.myDT_get_now(),
              it10cy20: global.c?.state.sgcd_pagePntKeys.cm10_key || '',
              it10cx10: pd.it10.d_flds.it10cx10 || '9999',
              it10cw10: pd.it10.d_flds.it10cw10 || bf.myCM_gnr(10),
            };
            return _d;
          },
        },
      },
    });

    await cf.myCB_call_tree({
      ctr: 'iud',
      state: 'sdld_chkIss2',
      dd_elmDefss: {
        it10: {
          od_insDats: pd => {
            let _d = {
              it10b11k: global.c?.state.sgcd_pagePntKeys.cm20_key || '0',
              it10b21k: global.c?.state.sgcd_pagePntKeys.cm10_key || '0',
              it10b31k: global.c?.state.sgcd_pagePntKeys.cm30_key || '0',
              it10l11e: 'prcChk',
              it10l11k: global.c?.state.sgc_pageKey,
              it10c110: '',
              it10c310: pd.it10.d_flds.it10c310,
              it10cz10: '10', // 表示 
              it10t110: ip.$o_pmn({
                mode: 'type',
              }),
              it10cy10: bf.myDT_get_now(),
              it10cy20: global.c?.state.sgcd_pagePntKeys.cm10_key || '',
              it10cx10: pd.it10.d_flds.it10cx10 || '9999',
              it10cw10: pd.it10.d_flds.it10cw10 || bf.myCM_gnr(10),
            };
            return _d;
          },
        },
      },
    });

    await cf.myCB_call_tree({
      ctr: 'iud',
      state: 'sdld_caseIss1',
      dd_elmDefss: {
        it10: {
          od_insDats: pd => {
            let _d = {
              it10b11k: global.c?.state.sgcd_pagePntKeys.cm20_key || '0',
              it10b21k: global.c?.state.sgcd_pagePntKeys.cm10_key || '0',
              it10b31k: global.c?.state.sgcd_pagePntKeys.cm30_key || '0',
              it10l11e: 'prcCase',
              it10l11k: global.c?.state.sgc_pageKey,
              it10c110: '',
              it10c310: pd.it10.d_flds.it10c310,
              it10cz10: '10', // 表示 
              it10t110: ip.$o_pmn({
                mode: 'type',
              }),
              it10cy10: bf.myDT_get_now(),
              it10cy20: global.c?.state.sgcd_pagePntKeys.cm10_key || '',
              it10cx10: pd.it10.d_flds.it10cx10 || '9999',
              it10cw10: pd.it10.d_flds.it10cw10 || bf.myCM_gnr(10),
            };
            return _d;
          },
        },
      },
    });

bf.l('575: {}'.f(global.c?.state.sdld_caseIss2))
    await cf.myCB_call_tree({
      ctr: 'iud',
      state: 'sdld_caseIss2',
      dd_elmDefss: {
        it10: {
          od_insDats: pd => {
            let _d = {
              it10b11k: global.c?.state.sgcd_pagePntKeys.cm20_key || '0',
              it10b21k: global.c?.state.sgcd_pagePntKeys.cm10_key || '0',
              it10b31k: global.c?.state.sgcd_pagePntKeys.cm30_key || '0',
              it10l11e: 'prcCase',
              it10l11k: global.c?.state.sgc_pageKey,
              it10c110: '',
              it10c310: pd.it10.d_flds.it10c310,
              it10cz10: '10', // 表示 
              it10t110: ip.$o_pmn({
                mode: 'type',
              }),
              it10cy10: bf.myDT_get_now(),
              it10cy20: global.c?.state.sgcd_pagePntKeys.cm10_key || '',
              it10cx10: pd.it10.d_flds.it10cx10 || '9999',
              it10cw10: pd.it10.d_flds.it10cw10 || bf.myCM_gnr(10),
            };
//bf.l('599: {}'.f(_d))
            return _d;
          },
        },
      },
    });

    await cp.$cp_hlr_ct10({ // ファイル情報
      mode: 'upd',
      elm: 'cm40',
      key: global.c?.state.sgc_pageKey,
      state: 'sld_filess1',
      ct10t110: '20',
    });

    await cp.$cp_hlr_ct10({ // ファイル情報
      mode: 'upd',
      elm: 'cm40',
      key: global.c?.state.sgc_pageKey,
      state: 'sld_filess2',
      ct10t110: '10',
    });

    _o_end1();
  })
*/
];

  $cld_onChgss = cp.cld_onChgss;

  $pld_onChgss = () => [
  ];

  render() {
/*
          rhtPfx={null}
*/

    let _sfxH = (global.c?.state.sgcd_pagePntKeys.cm31c410 == '20') ? (ic.gn_fontSizeSml + ic.gn_mgnSml * 2) * 2 : 0;
    let _sfxH1 = (global.c?.state.sgcd_pagePntKeys.cm31c410 == '20') ? (ic.gn_fontSizeSml + ic.gn_mgnSml * 2) * 1 : 0;

bf.l('640: {}, {}'.f(global.c?.state.sgcd_dmns.n_h, global.c?.state.sgcd_dmns.n_bdyH))
    return (
      <this.$onChg>
        <ce.RootDtl
          key={-1}
          b_logo={false}
          b_rhtVsb={(global.c?.state.sgcd_pagePntKeys?.cm31cz10 == '0') ? false : true}
          rhtPfx={
            bf.i(global.c?.state.sgc_pageMode, ['new', 'edit']) ?
              '反映'
            :
              '登録・変更'
          }
          rhtIconName={null} 
          onRhtPrs={null}
          d_hdrs={{
            pfx:  iv._get_hdrPfx((global.c?.state.sgcd_pagePntKeys.cm31c410 == '20') ? '業務設定' : '業務情報'),
            d_leftBtns: iv._get_leftBtns(global.c?.state.sgc_pageRole, cf.myNV_get_name(), global.c?.state.sgc_pageMode),
            d_subMenus: {
              b_vsb: false,
            },
          }}
          d_bdys={{
            ld_defss: [
              {
                type: 'Inp',
                b_vsb: true,
                b_edt: false,
                state:'s_cm30c310',
                pfx:'部門',
                b_mln:false,
              },

              {
                type:'Inp',
                b_vsb:true,
                b_edt:(
                  bf.i(global.c?.state.sgc_pageMode, ['new', 'edit']) && 
                  ip.$o_pmn({
                    mode: 'eblPage',
                    t110: global.c?.state.s_cm40t110,
                  })
                ) ? true : false,
                state:'s_cm40c310',
                pfx:'業務　※部門運営者のみ変更可',
                b_mln:false,
              },

              {
                type: 'InpTree3',
                state: 'sdld_chkIss1',
//                b_vsb: true,
                b_vsb: 
                  (
                    global.c?.state.sgcd_pagePntKeys.cm31c410 == '10' && 
                    bf.i(global.c?.state.sgc_pageMode, ['edit'])
                  ) ? 
                    false 
                  : true,
                b_edt: (bf.i(global.c?.state.sgc_pageMode, ['new', 'edit'])) ? true : false,
                dd_elmDefss: {
                  it10: {
                    pfx: '確認事項（共通）',
                    d_insDats: {
                      d_flds: {
                        it10b21k: global.c?.state.sgcd_pagePntKeys.cm10_key,
                        it10c310: '',
                        it10t110: (global.c?.state.sgcd_pagePntKeys.cm31c410 == '20') ? '20' : '10',
                      },
                    },
                    dd_fldDefss: {
                      it10c310: {
                        type: 'Inp',
                        phd: '確認事項を入力ください',
                        o_sfx: 
                          (global.c?.state.sgcd_pagePntKeys.cm31c410 == '20' && bf.i(global.c?.state.sgc_pageMode, ['show', 'edit'])) ? 
                            _d_dats => {
                              return '登録:{}, ID:{}'.f(_d_dats.d_flds.cm10c310, _d_dats.d_flds.it10cw10);
                            }
                          : null
                        ,
                        b_mln: true,
                        ob_vsb: _d_dats => {
                          let _b = ip.$o_pmn({
                            mode: 'vsbLine', 
                            t110: _d_dats.d_flds.it10t110,
                            b21k: _d_dats.d_flds.it10b21k,
                          });
                          return _b;
                        },
                        o_stlCta: _d_dats => {
                          let _d = {}
                          if (global.c?.state.sgc_pageMode == 'show'){
                            _d = {
                              borderWidth: 0,
                              borderLeftWidth: ic.gn_bdrWNrm,
                              borderColor: ip.$o_pmn({
                                mode: 'ccd',
                                t110: _d_dats.d_flds.it10t110,
                              }),
                              marginBottom: _sfxH,
                            };
                          }
                          else {
                            _d = {
                              marginBottom: _sfxH,
                            };
                          };
                          return _d;
                        },
                        stlSfx: {
                          top: null,
                          left: null,
//                          bottom: 0,
                          bottom: - _sfxH,
                          right: ic.gn_mgnNrm * 2 + ic.gn_iconSizeSml,
                        },
                        b_btnPrs: 
                          (global.c?.state.sgcd_pagePntKeys.cm31c410 == '20' && bf.i(global.c?.state.sgc_pageMode, ['new', 'edit'])) ? 
                            true 
                          : false
                        ,
                        btnIconName: 
                          (global.c?.state.sgcd_pagePntKeys.cm31c410 == '20' && bf.i(global.c?.state.sgc_pageMode, ['new', 'edit'])) ? 
                            'check'
                          : null
                        ,
                        onBtnPrs: 
                          (global.c?.state.sgcd_pagePntKeys.cm31c410 == '20' && bf.i(global.c?.state.sgc_pageMode, ['new', 'edit'])) ? 
                            _d_flds => {
                              if (bf.i(global.c?.state.sgc_pageMode, ['new'])) global.c?.ins();
                              if (bf.i(global.c?.state.sgc_pageMode, ['edit'])) global.c?.upd();
                            }
                          : null
                        ,
                      },
                    },
                    ld_sortss: [
                      {fld: 'it10t110', dtn: 'desc', mode: 'nmb'},
                      {fld: '_KEY', dtn: 'asc', mode: 'nmb'},
                    ],
                  },
                },
              },

              {
                type: 'InpTree3',
                state: 'sdld_chkIss2',
                b_vsb: true,
                b_edt: (bf.i(global.c?.state.sgc_pageMode, ['new', 'edit'])) ? true : false,
                dd_elmDefss: {
                  it10: {
                    pfx: '確認事項（個人）',
                    d_insDats: 
                      (global.c?.state.sgcd_pagePntKeys.cm31c410 == '10') ? 
                        {
                          d_flds: {
                            it10b21k: global.c?.state.sgcd_pagePntKeys.cm10_key,
                            it10c310: '',
                            it10t110: (global.c?.state.sgcd_pagePntKeys.cm31c410 == '20') ? '20' : '10',
                          },
                        }
                      : null
                    ,
                    dd_fldDefss: {
                      it10c310: {
                        type: 'Inp',
                        phd: '確認事項を入力ください',
                        o_sfx: 
                          (global.c?.state.sgcd_pagePntKeys.cm31c410 == '20' && bf.i(global.c?.state.sgc_pageMode, ['show', 'edit'])) ? 
                            _d_dats => {
                              return '登録:{}, ID:{}'.f(_d_dats.d_flds.cm10c310, _d_dats.d_flds.it10cw10);
                            }
                          : null
                        ,
                        b_mln: true,
                        o_stlCta: _d_dats => {
                          let _d = {}
                          if (global.c?.state.sgc_pageMode == 'show'){
                            _d = {
                              borderWidth: 0,
                              borderLeftWidth: ic.gn_bdrWNrm,
                              borderColor: ip.$o_pmn({
                                mode: 'ccd',
                                t110: _d_dats.d_flds.it10t110,
                              }),
                              marginBottom: _sfxH,
                            };
                          }
                          else {
                            _d = {
                              marginBottom: _sfxH,
                            };
                          };
                          return _d;
                        },
                        stlSfx: {
                          top: null,
                          left: null,
//                          bottom: 0,
                          bottom: - _sfxH,
                          right: ic.gn_mgnNrm * 2 + ic.gn_iconSizeSml,
                        },
                        ob_edt: _d_dats => 
                          (
                            global.c?.state.sgcd_pagePntKeys.cm31c410 == '10' && 
                            bf.i(global.c?.state.sgc_pageMode, ['new', 'edit'])
                          ) ? 
                            true 
                          : false
                        ,
                        b_dltPrs:
                          (global.c?.state.sgcd_pagePntKeys.cm31c410 == '10' && bf.i(global.c?.state.sgc_pageMode, ['new', 'edit'])) ? 
                            true
                          : false
                        ,
                        b_btnPrs: 
                          (global.c?.state.sgcd_pagePntKeys.cm31c410 == '20' && bf.i(global.c?.state.sgc_pageMode, ['new', 'edit'])) ? 
                            true 
                          : (global.c?.state.sgcd_pagePntKeys.cm31c410 == '10' && bf.i(global.c?.state.sgc_pageMode, ['new', 'edit'])) ? 
                            true 
                          : false
                        ,
                        btnIconName: 
                          (global.c?.state.sgcd_pagePntKeys.cm31c410 == '20' && bf.i(global.c?.state.sgc_pageMode, ['new', 'edit'])) ? 
                            'clipboard'
                          : (global.c?.state.sgcd_pagePntKeys.cm31c410 == '10' && bf.i(global.c?.state.sgc_pageMode, ['new', 'edit'])) ? 
                            'check'
                          : null
                        ,
                        onBtnPrs: 
                          (global.c?.state.sgcd_pagePntKeys.cm31c410 == '20' && bf.i(global.c?.state.sgc_pageMode, ['new', 'edit'])) ? 
                            _d_flds => {
                              cf.myCL_set(_d_flds.it10c310);
                            }
                          : (global.c?.state.sgcd_pagePntKeys.cm31c410 == '10' && bf.i(global.c?.state.sgc_pageMode, ['new', 'edit'])) ? 
                            _d_flds => {
                              if (bf.i(global.c?.state.sgc_pageMode, ['new'])) global.c?.ins();
                              if (bf.i(global.c?.state.sgc_pageMode, ['edit'])) global.c?.upd();
                            }
                          : null
                        ,
/*
                        btnStlCta: 
                          (global.c?.state.sgcd_pagePntKeys.cm31c410 == '20' && bf.i(global.c?.state.sgc_pageMode, ['new', 'edit'])) ? 
                            { 
                              top: null,
                              left: null,
                              bottom: 0,
                              right: 0,
                            }
                          : null
                        ,
*/
                      },
                    },
                    ld_sortss: [
                      {fld: 'it10t110', dtn: 'desc', mode: 'nmb'},
                      {fld: '_KEY', dtn: 'asc', mode: 'nmb'},
                    ],
                  },
                },
              },

              {
                type: 'InpTree3',
                state: 'sdld_caseIss1',
                b_vsb: 
                  (
                    global.c?.state.sgcd_pagePntKeys.cm31c410 == '10' && 
                    bf.i(global.c?.state.sgc_pageMode, ['edit'])
                  ) ? 
                    false 
                  : true,
                b_edt: (bf.i(global.c?.state.sgc_pageMode, ['new', 'edit'])) ? true : false,
                dd_elmDefss: {
                  it10: {
                    pfx: '失敗・クレーム事例（共通）',
                    d_insDats: {
                      d_flds: {
                        it10b21k: global.c?.state.sgcd_pagePntKeys.cm10_key,
                        it10c310: '',
                        it10t110: (global.c?.state.sgcd_pagePntKeys.cm31c410 == '20') ? '20' : '10',
                      },
                    },
                    dd_fldDefss: {
                      it10c310: {
                        type: 'Inp',
                        phd: '失敗・クレーム事例を入力ください',
                        o_sfx: 
                          (global.c?.state.sgcd_pagePntKeys.cm31c410 == '20' && bf.i(global.c?.state.sgc_pageMode, ['show', 'edit'])) ? 
                            _d_dats => {
                              return '登録:{}, ID:{}'.f(_d_dats.d_flds.cm10c310, _d_dats.d_flds.it10cw10);
                            }
                          : null
                        ,
                        stlSfx: {
                          top: null,
                          left: null,
//                          bottom: 0,
                          bottom: - _sfxH,
                          right: ic.gn_mgnNrm * 2 + ic.gn_iconSizeSml,
                        },
                        b_mln: true,
                        ob_vsb: _d_dats => {
                          let _b = ip.$o_pmn({
                            mode: 'vsbLine', 
                            t110: _d_dats.d_flds.it10t110,
                            b21k: _d_dats.d_flds.it10b21k,
                          });
                          return _b;
                        },
                        o_stlCta: _d_dats => {
                          let _d = {}
                          if (global.c?.state.sgc_pageMode == 'show'){
                            _d = {
                              borderWidth: 0,
                              borderLeftWidth: ic.gn_bdrWNrm,
                              borderColor: ip.$o_pmn({
                                mode: 'ccd',
                                t110: _d_dats.d_flds.it10t110,
                              }),
                              marginBottom: _sfxH,
                            };
                          }
                          else {
                            _d = {
                              marginBottom: _sfxH,
                            };
                          };
                          return _d;
                        },
                        b_btnPrs: 
                          (global.c?.state.sgcd_pagePntKeys.cm31c410 == '20' && bf.i(global.c?.state.sgc_pageMode, ['new', 'edit'])) ? 
                            true 
                          : false
                        ,
                        btnIconName: 
                          (global.c?.state.sgcd_pagePntKeys.cm31c410 == '20' && bf.i(global.c?.state.sgc_pageMode, ['new', 'edit'])) ? 
                            'check'
                          : null
                        ,
                        onBtnPrs: 
                          (global.c?.state.sgcd_pagePntKeys.cm31c410 == '20' && bf.i(global.c?.state.sgc_pageMode, ['new', 'edit'])) ? 
                            _d_flds => {
                              if (bf.i(global.c?.state.sgc_pageMode, ['new'])) global.c?.ins();
                              if (bf.i(global.c?.state.sgc_pageMode, ['edit'])) global.c?.upd();
                            }
                          : null
                        ,
                      },
                    },
                  },
                },
              },

              {
                type: 'InpTree3',
                state: 'sdld_caseIss2',
                b_vsb: true,
                b_edt: (bf.i(global.c?.state.sgc_pageMode, ['new', 'edit'])) ? true : false,
                dd_elmDefss: {
                  it10: {
                    pfx: '失敗・クレーム事例（個人）',
                    d_insDats: 
                      (global.c?.state.sgcd_pagePntKeys.cm31c410 == '10') ? 
                        {
                          d_flds: {
                            it10b21k: global.c?.state.sgcd_pagePntKeys.cm10_key,
                            it10c310: '',
                            it10t110: (global.c?.state.sgcd_pagePntKeys.cm31c410 == '20') ? '20' : '10',
                          },
                        }
                      : null
                    ,
                    dd_fldDefss: {
                      it10c310: {
                        type: 'Inp',
                        phd: '失敗・クレーム事例を入力ください',
                        o_sfx: 
                          (global.c?.state.sgcd_pagePntKeys.cm31c410 == '20' && bf.i(global.c?.state.sgc_pageMode, ['show', 'edit'])) ? 
                            _d_dats => {
                              return '登録:{}, ID:{}'.f(_d_dats.d_flds.cm10c310, _d_dats.d_flds.it10cw10);
                            }
                          : null
                        ,
                        b_mln: true,
                        o_stlCta: _d_dats => {
                          let _d = {}
                          if (global.c?.state.sgc_pageMode == 'show'){
                            _d = {
                              borderWidth: 0,
                              borderLeftWidth: ic.gn_bdrWNrm,
                              borderColor: ip.$o_pmn({
                                mode: 'ccd',
                                t110: _d_dats.d_flds.it10t110,
                              }),
                              marginBottom: _sfxH,
                            };
                          }
                          else {
                            _d = {
                              marginBottom: _sfxH,
                            };
                          };
                          return _d;
                        },
                        stlSfx: {
                          top: null,
                          left: null,
//                          bottom: 0,
                          bottom: - _sfxH,
                          right: ic.gn_mgnNrm * 2 + ic.gn_iconSizeSml,
                        },
                        ob_edt: _d_dats => 
                          (
                            global.c?.state.sgcd_pagePntKeys.cm31c410 == '10' && 
                            bf.i(global.c?.state.sgc_pageMode, ['new', 'edit'])
                          ) ? 
                            true 
                          : false
                        ,
                        b_dltPrs:
                          (global.c?.state.sgcd_pagePntKeys.cm31c410 == '10' && bf.i(global.c?.state.sgc_pageMode, ['new', 'edit'])) ? 
                            true
                          : false
                        ,
                        b_btnPrs: 
                          (global.c?.state.sgcd_pagePntKeys.cm31c410 == '20' && bf.i(global.c?.state.sgc_pageMode, ['new', 'edit'])) ? 
                            true 
                          : (global.c?.state.sgcd_pagePntKeys.cm31c410 == '10' && bf.i(global.c?.state.sgc_pageMode, ['new', 'edit'])) ? 
                            true 
                          : false
                        ,
                        btnIconName: 
                          (global.c?.state.sgcd_pagePntKeys.cm31c410 == '20' && bf.i(global.c?.state.sgc_pageMode, ['new', 'edit'])) ? 
                            'clipboard'
                          : (global.c?.state.sgcd_pagePntKeys.cm31c410 == '10' && bf.i(global.c?.state.sgc_pageMode, ['new', 'edit'])) ? 
                            'check'
                          : null
                        ,
                        onBtnPrs: 
                          (global.c?.state.sgcd_pagePntKeys.cm31c410 == '20' && bf.i(global.c?.state.sgc_pageMode, ['new', 'edit'])) ? 
                            _d_flds => {
                              cf.myCL_set(_d_flds.it10c310);
                            }
                          : (global.c?.state.sgcd_pagePntKeys.cm31c410 == '10' && bf.i(global.c?.state.sgc_pageMode, ['new', 'edit'])) ? 
                            _d_flds => {
                              if (bf.i(global.c?.state.sgc_pageMode, ['new'])) global.c?.ins();
                              if (bf.i(global.c?.state.sgc_pageMode, ['edit'])) global.c?.upd();
                            }
                          : null
                        ,
/*
                        btnStlCta: 
                          (global.c?.state.sgcd_pagePntKeys.cm31c410 == '20' && bf.i(global.c?.state.sgc_pageMode, ['new', 'edit'])) ? 
                            { 
                              top: null,
                              left: null,
                              bottom: 0,
                              right: 0,
                            }
                          : null
                        ,
*/
                      },
                    },
                  },
                },
              },

              {
                type:'Files',
                state:'sld_filess1',
                b_vsb: 
                  (
                    global.c?.state.sgcd_pagePntKeys.cm31c410 == '10' && 
                    bf.i(global.c?.state.sgc_pageMode, ['edit'])
                  ) ? 
                    false 
                  : true,
                o_vsb: _d_is => {
                  let _b = ip.$o_pmn({
                    mode: 'vsbLine', 
                    t110: _d_is.ct10t110,
                    b21k: _d_is.ct10cy20, 
                  });
                  return _b;
                },
                b_lblBtnVsb: (bf.i(global.c?.state.sgc_pageMode, ['new', 'edit'])) ? true : false,
                ob_dltBtnVsb: _d_is => {
                  let _b = ip.$o_pmn({
                    mode: 'eblLine',
                    t110: _d_is.ct10t110,
                    cy20: _d_is.ct10cy20,
                  });
                  return (bf.i(global.c?.state.sgc_pageMode, ['new', 'edit']) && _b) ? true : false;
                },
                pfx:'添付ファイル（共通）',
                o_sfx: 
                  (global.c?.state.sgcd_pagePntKeys.cm31c410 == '20' && bf.i(global.c?.state.sgc_pageMode, ['show', 'edit'])) ? 
                    _d_files => {
                      return _d_files.d_ct10s.cm10c310
                    }
                  :
                    null
                ,                
                ct10t110: (global.c?.state.sgcd_pagePntKeys.cm31c410 == '20') ? '20' : '10',
                o_stlCta: _d_is => {
                  let _d = {};
                  if (global.c?.state.sgc_pageMode == 'show'){
                    _d = {
                      borderWidth: 0,
                      borderLeftWidth: ic.gn_bdrWNrm,
                      borderColor: ip.$o_pmn({
                        mode: 'ccd',
                        t110: _d_is.ct10t110,
                      }),
                      marginBottom: _sfxH1,
                    };
                  }
                  else {
                    _d = {
                      marginBottom: _sfxH1,
                    };
                  };
                  return _d;
                },
                stlSfx: {
                  bottom: - _sfxH1,
                },
              },

              {
                type:'Files',
                state:'sld_filess2',
//                b_vsb:true,
/*
                b_vsb: 
                  (
                    global.c?.state.sgcd_pagePntKeys.cm31c410 == '20' && 
                    bf.i(global.c?.state.sgc_pageMode, ['edit'])
                  ) ? 
                    false 
                  : true,
*/
                o_vsb: _d_is => {
                  let _b = ip.$o_pmn({
                    mode: 'vsbLine', 
                    t110: _d_is.ct10t110,
                    b21k: _d_is.ct10cy20, 
                  });
//_b = true;
//bf.l('1006: {}'.f(global.c?.state.sld_filess2));
                  return _b;
                },
//                b_lblBtnVsb: (bf.i(global.c?.state.sgc_pageMode, ['new', 'edit'])) ? true : false,
                b_lblBtnVsb: 
                  (global.c?.state.sgcd_pagePntKeys.cm31c410 == '10' && bf.i(global.c?.state.sgc_pageMode, ['new', 'edit'])) ?
                    true
                  : false
                ,
/*
                ob_dltBtnVsb: _d_is => {
                  let _b = ip.$o_pmn({
                    mode: 'eblLine',
                    t110: _d_is.ct10t110,
                    cy20: _d_is.ct10cy20,
                  });
                  return (bf.i(global.c?.state.sgc_pageMode, ['new', 'edit']) && _b) ? true : false;
                },
*/
                b_dltBtnVsb:
                  (global.c?.state.sgcd_pagePntKeys.cm31c410 == '10' && bf.i(global.c?.state.sgc_pageMode, ['new', 'edit'])) ?
                    true
                  : false
                ,
                pfx:'添付ファイル（個人）',
                o_sfx: 
                  (global.c?.state.sgcd_pagePntKeys.cm31c410 == '20' && bf.i(global.c?.state.sgc_pageMode, ['show', 'edit'])) ? 
                    _d_files => {
//bf.l('453: {}'.f(_d_files.d_ct10s.cm10c310))
                      return '登録:{}'.f(_d_files.d_ct10s.cm10c310)
                    }
                  :
                    null
                ,                
                ct10t110: (global.c?.state.sgcd_pagePntKeys.cm31c410 == '20') ? '20' : '10',
                o_stlCta: _d_is => {
                  let _d = {};
                  if (global.c?.state.sgc_pageMode == 'show'){
                    _d = {
                      borderWidth: 0,
                      borderLeftWidth: ic.gn_bdrWNrm,
                      borderColor: ip.$o_pmn({
                        mode: 'ccd',
                        t110: _d_is.ct10t110,
                      }),
                      marginBottom: _sfxH1,
                    };
                  }
                  else {
                    _d = {
                      marginBottom: _sfxH1,
                    };
                  };
                  return _d;
                },
                stlSfx: {
                  bottom: - _sfxH1,
                },
              },

              {
                type:'Inp',
                b_vsb: (global.c?.state.sgcd_pagePntKeys.cm31c410 == '20') ? true : false,
                b_edt:(bf.i(global.c?.state.sgc_pageMode, ['new', 'edit']) && ip.$o_pmn({ mode: 'eblPage', t110: global.c?.state.s_cm40t110 })) ? true : false,
                state:'s_cm40cw10',
                pfx:'業務ID　※部門運営者のみ変更可',
                b_mln:false,
              },

              {
                type:'Inp',
                b_vsb: (global.c?.state.sgcd_pagePntKeys.cm31c410 == '20') ? true : false,
                b_edt: (bf.i(global.c?.state.sgc_pageMode, ['new', 'edit']) && ip.$o_pmn({ mode: 'eblPage', t110: global.c?.state.s_cm40t110 })) ? true : false,
                state:'s_cm40cx10',
                ini: '9999',
                pfx:'表示順　※部門運営者のみ変更可',
                b_mln:false,
              },

/*
              {
                type:'Pck',
                b_vsb: (global.c?.state.sgcd_pagePntKeys.cm31c410 == '20') ? true : false,
                b_edt:(bf.i(global.c?.state.sgc_pageMode, ['new', 'edit']) && ip.$o_pmn({ mode: 'eblPage', t110: global.c?.state.s_cm40t110 })) ? true : false,
                state:'s_cm40cz10',
                ini: '10',
                pfx:'表示区分　※部門運営者のみ変更可',
                ld_iss: [
                  {key:'10', pfx: '削除しない'},
                  {key:'0', pfx: '削除する'},
                ],
              },
*/

            ],

          }}
        />
      </this.$onChg>
    );
  }

}
